import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import { LoyaltyPageApi } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import {
  createCMSQuery,
  DEFAULT_CMS_PAGE_SIZE,
  getCMSLocale,
} from '@/modules/cms';

export const useCMSLoyaltyMissions = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const query = useMemo(() => {
    return createCMSQuery({
      ...getCMSLocale(language),
      pagination: {
        pageSize: DEFAULT_CMS_PAGE_SIZE,
      },
      populate: {
        missions_blocks: {
          filters: {
            identifier: {
              $ne: 'anniversary',
            },
          },
          fields: ['identifier'],
          populate: {
            missions: {
              fields: ['name', 'groupKeyId'],
            },
          },
        },
      },
    });
  }, [language]);

  const {
    data = null,
    error,
    isLoading,
  } = useSWRImmutable<LoyaltyPageApi>(`/loyalty?${query}`, fetcherCMS);

  const missions = useMemo(() => {
    if (!data || !data.missionsBlocks) return [];
    return data.missionsBlocks.flatMap((block) => block.missions);
  }, [data]);

  return {
    data,
    missionsPending: isLoading,
    isError: error,
    missions,
  };
};
